module.exports = __webpack_public_path__ + "img/roadmap.b9cc1613.png";